import React from "react";

import {
    setOptionValue,
    setSelectedCategory,
    setSelectedRootProduct,
} from "../../apps/configurator/reducers";
import {
    categoriesSelector,
    optionPanelsSelector,
    optionValueSelector,
    rootProductSelector,
    selectedCategoriesSelector,
} from "../../apps/configurator/selectors";
import { useAppDispatch, useAppSelector } from "../../apps/reducers";
import {
    IOptionCode,
    IOptionSingleValue,
    IProduct,
} from "../../models/catalogue";
import { ITabCardsBlock } from "../../models/streamfield-blocks";
import { TabCardsBlock as TabCardsBlockComponent } from "../components/TabCardsBlock";

interface IProps {
    tabCards: ITabCardsBlock;
    theme?: string;
}

export const TabCardsBlock = (props: IProps): React.ReactNode => {
    const dispatch = useAppDispatch();
    const rootProduct = useAppSelector((rootState) =>
        rootProductSelector(rootState.configurator),
    );
    const rootProducts = useAppSelector(
        (rootState) => rootState.configurator.entities.rootProducts,
    );
    const categories = useAppSelector((rootState) =>
        categoriesSelector(rootState.configurator),
    );
    const optionPanels = useAppSelector((rootState) =>
        optionPanelsSelector(rootState.configurator),
    );
    const selectedCategories = useAppSelector((rootState) =>
        selectedCategoriesSelector(rootState.configurator),
    );
    const selectedOptionValues = useAppSelector((rootState) =>
        optionValueSelector(rootState.configurator),
    );
    const viewport = useAppSelector((rootState) => rootState.common.viewport);

    const handleSelectRootProduct = (product: IProduct) => {
        dispatch(setSelectedRootProduct(product));
    };

    const handleSelectCategory = (
        payload: Parameters<typeof setSelectedCategory>[0],
    ) => {
        dispatch(setSelectedCategory(payload));
    };

    const handleSelectAttribute = (
        namespace: string,
        code: IOptionCode,
        index: number,
        totalNumValues: number,
        value: IOptionSingleValue,
    ) => {
        dispatch(
            setOptionValue({
                namespace,
                code,
                index,
                totalNumValues,
                value,
            }),
        );
    };

    return (
        <TabCardsBlockComponent
            tabCards={props.tabCards}
            pageRootProducts={rootProducts}
            pageRootProductID={rootProduct ? rootProduct.id : null}
            pageProductNamespace={
                rootProduct ? rootProduct.product_class_slug : null
            }
            pageCategorySelectors={categories}
            pageOptionPanels={optionPanels}
            pageSelectedCategories={selectedCategories}
            pageSelectedOptionValues={selectedOptionValues}
            viewport={viewport}
            theme={props.theme}
            // onGetOptionValues={this.getOptionValues}
            onCardProductSelect={handleSelectRootProduct}
            onCardCategorySelect={handleSelectCategory}
            onCardAttributeSelect={handleSelectAttribute}
        />
    );
};
